import Vue from 'vue';
import CurrentDate from '@/helpers/date';

Vue.filter('firstLetter', (string) => {
    const name = string.toString()
    return name.substring(1, 0)
})

Vue.filter('firstLettersLimit', (string) => {
    const name = string.toString()
    return name.substring(3, 0)
})

Vue.filter('shortWebsiteName', (website) => {
    return website.replace(/(^\w+:|^)\/\//, '').replace('www.', '').substring(1, 0);
})

Vue.filter('toDec', (int) => {
    return int ? int.toFixed(2) : '0.00'
})

Vue.filter('toCurrentTime', (date, time) => {
    return CurrentDate.convertToLocalTime(date, time)
})
